import styled from 'styled-components'
import Text from '@/components/common/Text'
import Button from '@/components/ui/Button'
import React from 'react'
import { device } from '@/common/constants/device'
import { useDispatch } from 'react-redux'
import Icon from '@/components/common/Icon'
import BaseLink from '@/components/common/BaseLink'
import { close } from '@/store/modalsSlice'
import { PAYMENT_SOURCE } from '@/common/constants/cookies'
import { useTranslations } from 'next-intl'

const Card = styled.div`
  width: 100%;
  position: relative;
  border-radius: 26px;
  display: flex;
  flex-direction: column;

  @media ${device.tablet} {
    width: 100%;
    max-width: 100%;
  }

  &.selected {
    border: 1px solid #6a67da;
  }
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
  flex-grow: 1;
  margin-bottom: 24px;
`

const TopWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
`

const Image = styled.img`
  width: 32px;
  height: 32px;

  @media ${device.tablet} {
    width: 40px;
    height: 40px;
  }
`

const TextTitle = styled(Text)`
  color: #15151f;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -1px;
  font-size: 16px;

  @media ${device.tablet} {
    font-size: 32px;
  }
`

const TextWrapper = styled.div`
  display: grid;
  grid-template-columns: 16px auto;
  align-items: center;
  gap: 16px;
  font-size: 12px;

  @media ${device.tablet} {
    font-size: 16px;
  }
`

const BottomWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 12px;
`

const BaseLinkWrap = styled(BaseLink)``

const PremiumCard = ({ plan, modalContent }) => {
  const { description, icon, advantages } = plan
  const t = useTranslations('premium')
  const tOffers = useTranslations('offers')
  const dispatch = useDispatch()

  const closeModal = () => {
    dispatch(close())
    sessionStorage.setItem(PAYMENT_SOURCE, 'session')
  }

  return (
    <Card>
      <Header>
        <TopWrapper>
          <Image
            src={`/_next_static/premium/${icon}.svg`}
            alt="man-technologist"
          />
          <TextTitle weight="700" color="black">
            {description}
          </TextTitle>
        </TopWrapper>
        <BottomWrapper>
          {advantages.map((advantage, index) => (
            <TextWrapper key={index}>
              <Icon icon="check-premium" size="20" color={'grey'} />
              <Text weight="400" color="black">
                <span>
                  {t.rich(advantage, {
                    Bold: (children) => <strong>{children}</strong>,
                  })}
                </span>
              </Text>
            </TextWrapper>
          ))}
        </BottomWrapper>
      </Header>
      <BaseLinkWrap
        href={`/premium?plan=${plan.description.toLowerCase()}`}
        isChangePath={false}
      >
        <Button filled block onClick={closeModal}>
          {tOffers(modalContent.buttonText)}
        </Button>
      </BaseLinkWrap>
    </Card>
  )
}

export default PremiumCard
